export default {
    navigationBarTitleText: "获取服务",
    navigationBarBackgroundColor: "#DF773C",
};